
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artworks/[id]",
      function () {
        return require("private-next-pages/artworks/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artworks/[id]"])
      });
    }
  